import React from 'react';

export const ArrowUp = (props: { className?: string }) => {
    return (
        <svg
            className={props.className}
            width='10'
            height='10'
            viewBox='0 0 10 10'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M4.99996 9.24264V0.757359M4.99996 0.757359L0.757324 5M4.99996 0.757359L9.24261 5'
                stroke='currentColor'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default ArrowUp;
